import { $convertFromMarkdownString } from '@lexical/markdown';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useRef, useState } from 'react';
import { MarkdownImage } from 'src/company/templates/hooks/useConvertToMarkdownMutation';
import { createTransformers } from '../config/transformers';
import { replacePlaceholdersWithImages } from '../utils';

type MarkdownPluginProps = {
  defaultValue?: string;
  placeholderImages: MarkdownImage[];
};

export function MarkdownPlugin({ defaultValue, placeholderImages }: MarkdownPluginProps) {
  const [editor] = useLexicalComposerContext();
  const [initialized, setInitialized] = useState(false);
  const placeholderImagesRef = useRef(placeholderImages);

  useEffect(() => {
    placeholderImagesRef.current = placeholderImages;
  }, [placeholderImages]);

  useEffect(() => {
    if (initialized) {
      return;
    }
    if (defaultValue !== undefined) {
      const processedMarkdown = replacePlaceholdersWithImages(
        defaultValue,
        placeholderImagesRef.current,
      );

      editor.update(() => {
        const transformers = createTransformers(editor);
        $convertFromMarkdownString(processedMarkdown, transformers);
      });

      setInitialized(true);
    }
  }, [editor, initialized, defaultValue]);

  return null;
}
